import { connect } from 'react-redux'
import BoardSettingsCard from '../components/BoardSettingsCard'
import * as api from '../../../actions/api'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  return ({
    width,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleClickSwitch: (data) => {
      dispatch(api.user.update(data))
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BoardSettingsCard)


// WEBPACK FOOTER //
// ./src/Pages/Settings/containers/BoardSettingsCard.js